import { IoBusinessOutline } from "react-icons/io5";
import RegionCreateModal from "../Modal/RegionCreateModal";
import RegionListPage from "./RegionListPage";

const columns = [
  { header: "Division Name", key: "division" },
  { header: "Division Id", key: "divisionId" },
  { header: "State", key: "state" },
  { header: "Sub-Division", viewKey: "subDivisionList", viewTitle: "Sub Division List" },
  { header: "Created By", key: "createdBy" },
  { header: "Location Description", key: "locationDescription" },
];

const DivisionList = () => (
  <RegionListPage
    field="division"
    label="Division"
    viewTab="Division"
    CreateIcon={IoBusinessOutline}
    createLabel="Create Division"
    columns={columns}
    renderCreate={(p) => (
      <RegionCreateModal
        {...p}
        tab="Division"
        fieldName1="Division Name"
        fieldName2="Choose Sub Division"
      />
    )}
  />
);

export default DivisionList;